import axios from './api';

const LOOPBACK_HOSTS = new Set(['localhost', '127.0.0.1', '::1']);

const getBackendOrigin = () => {
  const fallbackOrigin = typeof window !== 'undefined' ? window.location.origin : 'http://localhost';

  try {
    return new URL(axios.defaults.baseURL || fallbackOrigin, fallbackOrigin).origin;
  } catch (e) {
    return fallbackOrigin;
  }
};

export const resolveMediaUrl = (mediaPath) => {
  if (!mediaPath) return '';
  if (mediaPath.startsWith('data:') || mediaPath.startsWith('blob:')) return mediaPath;

  const backendOrigin = getBackendOrigin();

  try {
    const mediaUrl = new URL(mediaPath, `${backendOrigin}/`);
    const isAbsoluteUrl = /^[a-z][a-z\d+.-]*:/i.test(mediaPath);

    if (isAbsoluteUrl && !LOOPBACK_HOSTS.has(mediaUrl.hostname)) {
      return mediaPath;
    }

    if (LOOPBACK_HOSTS.has(mediaUrl.hostname)) {
      return `${backendOrigin}${mediaUrl.pathname}${mediaUrl.search}${mediaUrl.hash}`;
    }

    return mediaUrl.toString();
  } catch (e) {
    return mediaPath;
  }
};

export const buildMediaImageDescriptor = (mediaPath, sizes = '160px') => {
  const src = resolveMediaUrl(mediaPath);
  if (!mediaPath || /^(?:data:|blob:)/i.test(mediaPath)) return { src, sizes };
  let parsed;
  try {
    parsed = new URL(mediaPath, `${getBackendOrigin()}/`);
  } catch (error) {
    return { src, sizes };
  }
  const isExternal = parsed.origin !== getBackendOrigin();
  const segments = parsed.pathname.split('/').filter(Boolean);
  if (isExternal || segments[0] !== 'uploads' || segments.length !== 2) return { src, sizes };
  const filename = segments[1].replace(/\.[^.]+$/, '') + '.webp';
  const urls = ['small', 'medium', 'large'].map(size => resolveMediaUrl(`/uploads/media/${size}/${encodeURIComponent(filename)}`));
  return {
    src,
    srcSet: urls.map((url, index) => `${url} ${[96, 320, 640][index]}w`).join(', '),
    sizes,
  };
};
